const COLLECTION_GET_ALL = "/v1/collections/getall";
const COLLECTION_GET_SINGLE = "/v1/collections/get";
const COLLECTION_ADD = "/v1/collections/add";
const COLLECTION_UPDATE = "/v1/collections/update";
const COLLECTION_DELETE = "/v1/collections/delete";
const COLLECTION_APPROVE = "/v1/bank/erp-collection-add"

const COLLECTION_API_URL_LIST = {
    COLLECTION_GET_ALL,
    COLLECTION_GET_SINGLE,
    COLLECTION_ADD,
    COLLECTION_UPDATE,
    COLLECTION_DELETE,
    COLLECTION_APPROVE
}

export { COLLECTION_API_URL_LIST };
